
  import {Vue} from "vue-property-decorator";
  import Component from "vue-class-component";
  import { useConsultorioStore } from '../../store/consultorioStore';
  import { globalStore } from '../../store/globalStore';
  import { consultorioService } from '../../services/ConsultorioService';
  import router from "../../router";
  import NewTratamiento from "./NewTratamiento.vue"
  import FormEdit from "./FormEdit.vue"
  
  @Component({
    name: "TratamientoIndex",
    components: {NewTratamiento, FormEdit}
  })
  export default class TratamientoIndex extends Vue {
    
    private globalStore = globalStore();
    private consultorioStore = useConsultorioStore();
    private consultorioService = consultorioService.getInstance();
    public dialog = false;
    
    public txtSearch = '';
    public tratamiento_selected = null;
    swEditar = false
    mounted(){
      this.getTratamientos();
    }
    getTratamientos(){
      this.loading
      this.consultorioService.getTratamientos()
    }
    editar(tratamiento:any){
      this.swEditar = true;
      this.tratamiento_selected = tratamiento
    }
    nuevoTratamiento(){
        this.dialog = true;
    }
    close(){
        this.dialog = false;
    }
    
    get datos(): any {
      return this.consultorioStore.tratamientos;
    }
    get loading(): boolean {
      return this.consultorioStore.loading;
    }

    get tratamientosFilter(): any {
      let data = this.datos;
      if(this.txtSearch != ''){
        return data.filter(val => val.nombre.toUpperCase().includes(this.txtSearch.toUpperCase()))
      }
      return data;
    }
    
  }
  